function mouseEventsModal() {
    const wDoc = window.document;
    const toggleBtns = wDoc.querySelectorAll('.js-toggle-card');
    toggleBtns &&
        toggleBtns.forEach((item) => {
            item.addEventListener('click', (event) => {
                const modals = wDoc.querySelectorAll('.modal-specification.open');
                const eTarget = event.target;
                const container = eTarget.closest('.modal-specification');
                if (container.classList.contains('open')) {
                    container.classList.remove('open');
                }
                else {
                    modals &&
                        modals.forEach((wrap) => {
                            wrap.classList.remove('open');
                        });
                    container.classList.add('open');
                }
            });
        });
}
export default mouseEventsModal;
